import {Component, Input} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';

@Component({
	selector: 'form-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {

	@Input()
	control: UntypedFormControl;

	@Input()
	id: string = this.dynamicIdService.getId('checkbox');

	@Input()
	label: string;

	@Input()
	template: ControlTemplate = ControlTemplate.inline;

	ControlTemplate = ControlTemplate;

	constructor(private dynamicIdService: DynamicIdService) {
	}
}
